import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { VolunteerForm } from '../components/forms/VolunteerForm';
export function VolunteerApply() {
  return <>
      <PageHero eyebrow="Volunteer application" title="Join the movement" intro="Five short steps. Your details are used only for campaign coordination and are never sold or shared." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Join',
      to: '/join'
    }, {
      label: 'Application'
    }]} data-id="element-1545" data-mp="1cip0hxxp5uv4" />
      <section className="bg-sand-50 py-14 lg:py-20" aria-label="Volunteer application form" data-id="element-1546" data-mp="2092ys66vkpy5">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10" data-id="element-1547" data-mp="1vg039sijf6fb">
          <VolunteerForm data-id="element-1548" data-mp="1qj9m11uzy4sb" />
        </div>
      </section>
    </>;
}